<template>
    <div>
        <h2>{{ $t("invoice.control_properties_porteuses") }}</h2>
        <div class="box">
            <DateRangeV2
                v-if="start_date && end_date"
                :start.sync="start_date"
                :end.sync="end_date"
                @submit="init_component"
                :dateSelect="true"
                :periodToShow="[ 'personalise', 'mois_dernier', 'mois']"
                periodLabel="mois"
            />

            <CustomTable
                id_table="control_properties_porteuses"
                :items="properties"
                :busy.sync="table_busy"
                primaryKey="contract_id"
                :hide_if_empty="true"
                :hrefsRoutes="config_table_hrefs"
                :externSlotColumns="['donneuse.propriete', 'donneuse.pension', 'donneuse.frais', 'porteuse.propriete', 'porteuse.pension', 'porteuse.frais']"
            >
                <template v-slot:[`custom-slot-cell(donneuse.propriete)`]="{ data }">
                    <template v-for="propriete in data.proprietaires_donneuse">
                        <router-link :to="{ name: 'tiersTableauBord', params: { tiers_id: propriete.tiers_id }}" :key="propriete.tiers_id">{{ propriete.tiers_rs }}</router-link> {{ propriete.propriete }}%
                    </template>
                </template>
                <template v-slot:[`custom-slot-cell(donneuse.pension)`]="{ data }">
                    <template v-for="propriete in data.proprietaires_donneuse">
                        <router-link :to="{ name: 'tiersTableauBord', params: { tiers_id: propriete.tiers_id }}" :key="propriete.tiers_id">{{ propriete.tiers_rs }}</router-link> {{ propriete.pension }}%
                    </template>
                </template>
                <template v-slot:[`custom-slot-cell(donneuse.frais)`]="{ data }">
                    <template v-for="propriete in data.proprietaires_donneuse">
                        <router-link :to="{ name: 'tiersTableauBord', params: { tiers_id: propriete.tiers_id }}" :key="propriete.tiers_id">{{ propriete.tiers_rs }}</router-link> {{ propriete.frais }}%
                    </template>
                </template>
                <template v-slot:[`custom-slot-cell(porteuse.propriete)`]="{ data }">
                    <template v-for="propriete in data.proprietaires_porteuse">
                        <router-link :to="{ name: 'tiersTableauBord', params: { tiers_id: propriete.tiers_id }}" :key="propriete.tiers_id">{{ propriete.tiers_rs }}</router-link> {{ propriete.propriete }}%
                    </template>
                </template>
                <template v-slot:[`custom-slot-cell(porteuse.pension)`]="{ data }">
                    <template v-for="propriete in data.proprietaires_porteuse">
                        <router-link :to="{ name: 'tiersTableauBord', params: { tiers_id: propriete.tiers_id }}" :key="propriete.tiers_id">{{ propriete.tiers_rs }}</router-link> {{ propriete.pension }}%
                    </template>
                </template>
                <template v-slot:[`custom-slot-cell(porteuse.frais)`]="{ data }">
                    <template v-for="propriete in data.proprietaires_porteuse">
                        <router-link :to="{ name: 'tiersTableauBord', params: { tiers_id: propriete.tiers_id }}" :key="propriete.tiers_id">{{ propriete.tiers_rs }}</router-link> {{ propriete.frais }}%
                    </template>
                </template>
            </CustomTable>
        </div>

        <b-modal ref="modalPension" hide-footer size="xxl" @hidden="selected_porteuse = null">
            <template v-slot:modal-title>
                {{ $t("horse.ajouter_pension") }}
            </template>

            <template v-if="selected_porteuse">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label for="nb_jours" class="col-form-label">{{ $t("invoice.pension_jours_apres_transplantation") }}</label>
                            <b-form-input id="nb_jours" type="number" min="0" v-model.number="nb_jours" />
                        </div>
                    </div>
                </div>

                <PensionAjout
                    ref="pensionAjout"
                    :horse="{ horse_id: selected_porteuse.porteuse.horse_id }"
                    :default_date="pension_start_date"
                    :add-or-edit-ready.sync="add_ready"
                />

                <b-button class="mt-3 btn-block rounded-pill" block @click.prevent="checkFormPension" variant="primary">
                    <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse /> {{ $t("global.ajouter") }}
                </b-button>
            </template>
        </b-modal>

        <b-modal ref="modalPercentage" hide-footer size="xxl" @hidden="selected_row_pct = null">
            <template v-slot:modal-title>
                {{ $t("tiers.ajouter_tiers_horse") }}
            </template>

            <template v-if="selected_row_pct">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label for="nb_jours_pct" class="col-form-label">{{ $t("invoice.pension_jours_apres_transplantation") }}</label>
                            <b-form-input id="nb_jours_pct" type="number" min="0" v-model.number="nb_jours_pct" />
                        </div>
                    </div>
                </div>

                <HorseAjout
                    ref="horseAjout"
                    :horse="{ horse_id: selected_row_pct.porteuse.horse_id }"
                    :preset_tiers="preset_tiers"
                    :default_date="percentage_date"
                    :tiers_horse="[]"
                    :add-or-edit-ready.sync="add_ready_pct"
                />

                <b-button class="mt-3 btn-block rounded-pill" block @click.prevent="checkFormPercentage" variant="primary">
                    <font-awesome-icon v-if="processing_pct" :icon="['fas', 'spinner']" pulse /> {{ $t("global.ajouter") }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script type="text/javascript">
    import Invoice from "@/mixins/Invoice.js"
    import Navigation from "@/mixins/Navigation.js"
    import Horse from "@/mixins/Horse.js"

    export default {
        name: "controlPropertiesActes",
        mixins: [Invoice, Navigation, Horse],
        data () {
            return {
                start_date: new Date(new Date().setMonth(new Date().getMonth() - 1)),
                end_date: new Date(),
                properties: [],
                table_busy: true,
                config_table_hrefs: {
                    'donneuse.horse_nom': {
                        routeUniqueName: 'donneuseFiche',
                        routeName: 'horseFiche',
                        params: {
                            horse_id: 'donneuse.horse_id'
                        }
                    },
                    'porteuse.horse_nom': {
                        routeUniqueName: 'porteuseFiche',
                        routeName: 'horseFiche',
                        params: {
                            horse_id: 'porteuse.horse_id'
                        }
                    },
                    'contract_num': {
                        routeUniqueName: 'contract',
                        routeName: 'ContractFormv2',
                        params: {
                            contract_id: 'contract_id'
                        }
                    }
                },
                events_tab: {
                    'TableAction::goToAddPensionPorteuse': this.openModalPension,
                    'TableAction::goToAffectPercentage': this.openModalPercentage
                },
                selected_porteuse: null,
                nb_jours: 0,
                add_ready: false,
                processing: false,
                selected_row_pct: null,
                preset_tiers: null,
                nb_jours_pct: 0,
                add_ready_pct: false,
                processing_pct: false
            }
        },
        methods: {
            async init_component() {
                this.table_busy = true
                this.properties = await this.controlPropertiesPorteuses(this.start_date.toDateInputValue(), this.end_date.toDateInputValue())
                this.table_busy = false
            },
            openModalPension(porteuse) {
                this.selected_porteuse = porteuse
                this.nb_jours = 0
                this.add_ready = false
                this.$refs.modalPension.show()
            },
            async checkFormPension() {
                if(this.processing) return
                this.processing = true
                const result = await this.$refs.pensionAjout.checkForm()
                if(result) {
                    this.$refs.modalPension.hide()
                    this.init_component()
                }
                this.processing = false
            },
            async openModalPercentage(row) {
                this.nb_jours_pct = 0

                // Tiers actuels de la porteuse (avec leur tiershorse_id pour mise à jour et non duplication)
                const porteuse = await this.loadTiersCurrentPart(row.porteuse.horse_id)
                const current = porteuse ? porteuse.tiers_horse : []
                const current_ids = current.map(t => t.tiers.tiers_id)

                // Tiers de la donneuse absents de la porteuse, pré-remplis avec leurs %
                const donneuse_missing = row.proprietaires_donneuse.filter(d => !current_ids.includes(d.tiers_id)).map(d => ({
                    tiershorse_id: null,
                    tiers: { tiers_id: d.tiers_id, tiers_rs: d.tiers_rs },
                    tiers_horse_part: {
                        tiershorsepart_propriete: d.propriete,
                        tiershorsepart_pension: d.pension,
                        tiershorsepart_frais: d.frais,
                        tiershorsepart_contract: 0,
                        tiershorsepart_entraineur: 0,
                        tiershorsepart_jockey: 0
                    }
                }))

                this.preset_tiers = [...current, ...donneuse_missing]
                this.add_ready_pct = false
                // En dernier : déclenche le rendu de HorseAjout une fois preset_tiers prêt
                this.selected_row_pct = row
                this.$refs.modalPercentage.show()
            },
            async checkFormPercentage() {
                if(this.processing_pct) return
                this.processing_pct = true
                const result = await this.$refs.horseAjout.checkForm()
                if(result) {
                    this.$refs.modalPercentage.hide()
                    this.init_component()
                }
                this.processing_pct = false
            }
        },
        computed: {
            pension_start_date() {
                if(!this.selected_porteuse || !this.selected_porteuse.transplantation_date) return null
                const date = new Date(this.selected_porteuse.transplantation_date)
                date.setDate(date.getDate() + (parseInt(this.nb_jours) || 0))
                return date
            },
            pension_start_date_label() {
                return this.pension_start_date ? this.pension_start_date.toLocaleDateString('fr-FR') : ''
            },
            percentage_date() {
                if(!this.selected_row_pct || !this.selected_row_pct.transplantation_date) return null
                const date = new Date(this.selected_row_pct.transplantation_date)
                date.setDate(date.getDate() + (parseInt(this.nb_jours_pct) || 0))
                return date
            },
            percentage_date_label() {
                return this.percentage_date ? this.percentage_date.toLocaleDateString('fr-FR') : ''
            }
        },
        components: {
            CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
            DateRangeV2: () => import('GroomyRoot/components/Inputs/DateRangeV2'),
            PensionAjout: () => import('@/components/Horse/PensionAjout'),
            HorseAjout: () => import('@/components/Tiers/HorseAjout')
        }
    }
</script>
